import { Icon } from "./Icon.tsx";

/** "Add Outfall" tool icon — a triangle (NetworkMap.tsx's own outfall marker shape) with a plus badge, same "shape + plus" convention as AddJunctionIcon. */
export function AddOutfallIcon() {
  return (
    <Icon>
      <path d="M10 8l5 10H5z" />
      <path d="M18 3v6M15 6h6" />
    </Icon>
  );
}
